
// Constants for i18n configuration
export const defaultNS = 'common';
export const fallbackLng = 'en';

// Map of language codes to their full names
export const languageNames = {
  en: 'English',
  es: 'Español',
  no: 'Norsk'
};
